import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chat-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 3.75c-.7 0-1.25.56-1.25 1.25v10c0 .7.56 1.25 1.25 1.25h3c.22 0 .42.1.55.24L12 19.94l3.47-3.47a.75.75 0 0 1 .53-.22h3c.7 0 1.25-.56 1.25-1.25V5c0-.7-.56-1.25-1.25-1.25H5Zm7.55 17.76-.02.02c-.3.3-.77.3-1.06 0l-3.78-3.78H5A2.75 2.75 0 0 1 2.25 15V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75h-2.69l-3.76 3.76Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.25 12c0-.41.34-.75.75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 8c0-.41.34-.75.75-.75h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Z"
    }, null, -1)
  ])))
}
export default { render: render }